import React, { useState } from "react";
import {
  IDropdownOption,
  IDropdownProps,
  SearchBox,
  Dropdown,
  DropdownMenuItemType,
  IRenderFunction,
  ISelectableDroppableTextProps,
  IDropdown,
} from "@fluentui/react";

export const noMatchOption: IDropdownOption = {
  text: "No Match",
  key: "NOMATCH",
  itemType: DropdownMenuItemType.Header,
};

export const DropdownSearch = ({ options, ...dropdownProps }: Omit<IDropdownProps, "onRenderOption">) => {
  let [items, setItems] = useState(options);

  const onSearch = (_, v) => {
    const newItems = options.filter(
      ({ text, key }) =>
        text.toString().toLowerCase().includes(v.toString().toLowerCase()) ||
        key.toString().toLowerCase().includes(v.toString().toLowerCase())
    );
    if (newItems.length == 0) {
      setItems([noMatchOption]);
    } else {
      setItems(newItems);
    }
  };

  const onDismiss = () => {
    setItems(options);
    dropdownProps.onDismiss?.();
  };

  const onRenderList: IRenderFunction<ISelectableDroppableTextProps<IDropdown, HTMLDivElement>> = (
    props,
    defaultRender
  ) => {
    return (
      <>
        <div style={{ position: "fixed", backgroundColor: "white", width: "100%", zIndex: "1" }}>
          <SearchBox
            onChange={onSearch}
            underlined={true}
            placeholder="Search..."
            onBlur={(e) => e.currentTarget.focus()}
          />
        </div>
        <div style={{ height: "40px" }} />
        {defaultRender(props)}
      </>
    );
  };

  return <Dropdown {...dropdownProps} onDismiss={onDismiss} onRenderList={onRenderList} options={items} />;
};
